import {} from 'react';

import { useGetFlowsV2Query } from '~/graphql/types';
import useCurrentAccount from '../useCurrentAccount';
import type { ApolloError } from '@apollo/client';

export type FlowInAccount = {
  id: string;
  name: string;
};

/**
 * Returns flows in the account, excluding the flows with the given ids
 *
 * @param {Array<string>} excludeFlowIds - Flow ids to exclude from the options
 *
 * @returns flows: Array<{ id: string; name: string; }>
 *          loading: boolean
 *          error: ApolloError | undefined
 */
const useFlows = ({
  excludeFlowIds = [],
}: {
  excludeFlowIds?: Array<string>;
} = {}): {
  flows: Array<FlowInAccount>;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const account = useCurrentAccount();
  const { data, loading, error } = useGetFlowsV2Query({
    variables: {
      accountId: account.id,
      limit: 999,
    },
  });

  if (!data) return { flows: [], loading, error };

  const flows = data.getFlowsV2.items
    .filter(flow => !excludeFlowIds.includes(flow.id))
    .map(flow => ({
      id: flow.id,
      name: flow.name,
    }));

  return {
    flows,
    loading,
    error,
  };
};

export default useFlows;
